/**
 * Étapes d'onboarding renvoyées par le backend dans la réponse de
 * /users/login et /users/me, et table de correspondance vers les
 * URLs du SPA.
 *
 * Le backend est la seule source de vérité sur l'ordre des étapes
 * et leurs conditions (cf. macadamia-backend/src/modules/auth/nextStep.ts).
 * Le frontend ne fait que mapper l'enum à ses propres routes.
 */

export type NextStep = 'verify-email' | 'onboarding-interests' | 'app';

export const NEXT_STEP_URL: Record<NextStep, string> = {
  'verify-email': '/verifier-email',
  'onboarding-interests': '/vos-centres-d-interet',
  app: '/documentation',
};

export function isNextStep(value: unknown): value is NextStep {
  return value === 'verify-email' || value === 'onboarding-interests' || value === 'app';
}

export function resolveNextStepUrl(nextStep: NextStep | undefined, fallback: string = '/documentation'): string {
  if (!nextStep) return fallback;
  return NEXT_STEP_URL[nextStep] ?? fallback;
}
